var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderCountTable" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.data,
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            border: "",
            fit: "",
            "max-height": "500"
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50", fixed: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_type_text", label: "类型" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "supply_time",
              label: "供货时间/售后确认时间",
              width: "130"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "sku_name", label: "商品名称", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_quantity", label: "数量", width: "50px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("fixedNumber")(scope.row.order_quantity))
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "unit", label: "单位", width: "50px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_price", label: "供货成交价" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_amount", label: "供货金额" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "real_settle_date",
              label: "结算时间",
              width: "130px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "payment_bill_status_text", label: "结算状态" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "total_amount", label: "结算金额" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "paid_on", label: "付款/扣款时间", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "main_number", label: "主订单号", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_number", label: "子订单号", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ap_order_status_text", label: "主单状态" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "shop_name", label: "三方名称", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "as_number", label: "售后单号", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "push_time", label: "推送时间", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ap_order_detail_status_text", label: "子单状态" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "sku_code", label: "锐锢编码", width: "100px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_status_text", label: "OMS单据状态" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "payment_bill_created_on",
              label: "核算确认时间",
              width: "130px"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "expect_settle_date",
              label: "预计结算时间",
              width: "130px"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13025802", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13025802","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/OrderCountTable.vue
// module id = null
// module chunks = 